import styled from 'styled-components';
import { ListReference } from 'modules/legacySegmentation/domain';
import { Link } from 'ui/links';
import { Cell } from './table';
import { TABLE_COLUMNS } from './constants';
import { getListReferenceUrl } from './utils';

type ListReferenceNameCellProps = {
  listReference: ListReference;
  rowIndex: number;
};

const StyledCell = styled(Cell)`
  && {
    width: 100%;
  }
`;

const StyledLabel = styled(Link)`
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledId = styled.div`
  font-size: ${({ theme }) => theme.styles.fontSizes.s12};
  letter-spacing: ${({ theme }) => theme.styles.letterSpacing.pos10};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
`;

export const ListReferenceNameCell = ({ listReference, rowIndex }: ListReferenceNameCellProps) => (
  <StyledCell data-test="list-usage-name-cell" columnId={TABLE_COLUMNS.NAME} rowIndex={rowIndex}>
    <StyledLabel href={getListReferenceUrl(listReference)} target="_blank">
      {listReference.name}
    </StyledLabel>
    <StyledId>{`ID: ${listReference.id}`}</StyledId>
  </StyledCell>
);
